if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
 }

document.addEventListener('DOMContentLoaded', function() {

    var slider = {
        speed: 1000,
        current: 0,
        el: document.getElementsByClassName('slider')[0],
        slides: document.querySelectorAll('.slider__slide'),
        moving: false,
        paginator: document.getElementsByClassName('slider__pagination')[0],

        changeSlide: function(slide) {
            this.current = slide;

            this.slides.forEach(
                function(slide, currentIndex, listObj) {
                    slide.classList.remove('active');
                }
            );

            this.slides[this.current].classList.add('active');
        },

        nextSlide: function() {
            this.moving = true;
            var self = this;

            this.slides[this.current].classList.add('leaving-to-right');
            this.slides[this.current].classList.remove('slider__slide--current');

            if ((this.current + 1) == this.slides.length) {
                this.current = 0;
            } else {
                this.current++;
            }

            this.paginator.querySelectorAll('.slider__pagination-link').forEach(function(page) {
                page.classList.remove('slider__pagination-link--active');
                if (page.dataset.slide == self.current) {
                    page.classList.add('slider__pagination-link--active');
                }
            });

            this.slides[this.current].classList.add('entering-from-left');

            setTimeout(function() {
                self.slides.forEach(function(slide) {
                    if (slide.classList.contains('entering-from-left')) {
                        slide.classList.remove('entering-from-left');
                        slide.classList.add('slider__slide--current');
                    } else {
                        slide.classList.remove('leaving-to-right');
                    }
                });

                self.moving = false;
            }, this.speed);
        },

        previousSlide: function() {
            var self = this;

            this.moving = true;

            this.slides[this.current].classList.add('leaving-to-left');
            this.slides[this.current].classList.remove('slider__slide--current');

            if (this.current == 0) {
                this.current = this.slides.length - 1;
            } else {
                this.current--;
            }

            this.paginator.querySelectorAll('.slider__pagination-link').forEach(function(page) {
                page.classList.remove('slider__pagination-link--active');
                if (page.dataset.slide == self.current) {
                    page.classList.add('slider__pagination-link--active');
                }
            });

            this.slides[this.current].classList.add('entering-from-right');

            setTimeout(function() {
                self.slides.forEach(function(slide) {
                    if (slide.classList.contains('entering-from-right')) {
                        slide.classList.remove('entering-from-right');
                        slide.classList.add('slider__slide--current');
                    } else {
                        slide.classList.remove('leaving-to-left');
                    }
                });

                self.moving = false;
            }, this.speed);
        },

        jumpTo: function(i) {
            this.moving = true;
            var self = this;

            this.slides[this.current].classList.add('leaving-to-left');
            this.slides[this.current].classList.remove('slider__slide--current');

            this.current = i;

            this.slides[this.current].classList.add('entering-from-right');

            this.paginator.querySelectorAll('.slider__pagination-link').forEach(function(page) {
                page.classList.remove('slider__pagination-link--active');
                if (page.dataset.slide == self.current) {
                    page.classList.add('slider__pagination-link--active');
                }
            });

            setTimeout(function() {
                self.slides.forEach(function(slide) {
                    if (slide.classList.contains('entering-from-right')) {
                        slide.classList.remove('entering-from-right');
                        slide.classList.add('slider__slide--current');
                    } else {
                        slide.classList.remove('leaving-to-left');
                    }
                });

                self.moving = false;
            }, this.speed);

        },

        createPaginatorItem: function(slide) {
        },

        init: function() {
            var self = this;

            this.el.querySelector('.slider__arrow--next').addEventListener('click', function(e) {
                e.preventDefault();
                if (!self.moving) {
                    self.nextSlide();
                }
            });

            this.el.querySelector('.slider__arrow--previous').addEventListener('click', function(e) {
                e.preventDefault();
                if (!self.moving) {
                    self.previousSlide();
                }
            });

            this.slides.forEach(function(slide, i) {
                var el = document.createElement('div');
                el.dataset.slide = i;
                el.classList.add('slider__pagination-link');

                if (i == 0) {
                    el.classList.add('slider__pagination-link--active');
                }

                el.addEventListener('click', function(e) {
                    e.preventDefault();
                    if (!self.moving) {
                        self.jumpTo(i);
                    }
                });

                self.paginator.appendChild(el);
            });
        }
    };

    slider.init();

});
